import { Button } from "primereact/button";
import "../../styles/components/Buttons.scss";
export interface SecondaryButtonProps {
  label?: string;
  size?: "small" | "large";
  className?: string;
  icon?: string;
  onClick?: () => void;
  isDisabled?: boolean;
  iconPos?: "left" | "right";
  dataTestId?: string;
}

/** Customized Primary Button - solid filled */
export const SecondaryButton = ({
  label,
  size,
  className,
  onClick,
  icon,
  isDisabled = false,
  iconPos = "left",
  dataTestId,
}: SecondaryButtonProps) => {
  return (
    <Button
      outlined
      onClick={onClick}
      label={label}
      icon={icon ?? icon}
      size={size}
      iconPos={iconPos ?? "left"}
      className={` outlined-button ${className}`}
      disabled={isDisabled}
      data-testid={dataTestId}
    />
  );
};
